import Hero from '../components/Hero';
import TrustIndicators from '../components/TrustIndicators';
import ServicesOverview from '../components/ServicesOverview';
import IndustriesSection from '../components/IndustriesSection';
import BusinessOutcomes from '../components/BusinessOutcomes';
import TechStack from '../components/TechStack';
import EngagementModels from '../components/EngagementModels';
import AboutSnapshot from '../components/AboutSnapshot';
import CTASection from '../components/CTASection';
import { usePageMeta } from '../hooks/usePageMeta';
import { useStructuredData, organizationSchema } from '../hooks/useStructuredData';
import '../styles/AboutPage.css';


export default function HomePage() {
  usePageMeta(
    'Kodefactor | IT Consulting & Digital Transformation',
    'Expert IT consulting, cloud migration, cybersecurity, DevOps, and AI engineering for businesses ready to scale.',
    'https://kodefactor.io',
    'https://kodefactor.io/og-image.jpg'
  );

  useStructuredData(organizationSchema);

  return (
    <div>
      <Hero />
      <TrustIndicators />
      <ServicesOverview />
      <IndustriesSection />
      <BusinessOutcomes />
      <TechStack />
      <EngagementModels />
      <AboutSnapshot />
      <CTASection />
    </div>
  );
}
